export default __webpack_public_path__ + "static/media/icons.c997af2f.svg";